export default "__VITE_ASSET__BQYKVAre__"